"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useRouter } from "next/navigation";
import { LIVE_CITY_ID } from "@/app/(fevicol-inhomz)/_constants/cities";
import { getStoredCityId } from "@/app/(fevicol-inhomz)/_constants/selectedCity";
import { fevicolInhomzRootRoute } from "@/app/(fevicol-inhomz)/_constants/tempRootRoute";
import { leaveFlow } from "@/components/get-in-touch/enquiryFlowHistory";
import { useEnquiryFlowStore } from "@/store/enquiryFlowStore";
import { inhomzEvents } from "@/app/(fevicol-inhomz)/_lib/events";
import { profileEventProps } from "@/app/(fevicol-inhomz)/_lib/profileEventProps";
import { useInhomzTrack } from "@/app/(fevicol-inhomz)/_hooks/useInhomzTrack";
import { useTrackWhenActive } from "@/app/(fevicol-inhomz)/_hooks/useTrackWhenActive";

// The confirmation step (content only, no overlay/backdrop of its own) —
// hosted as its own sliding page by EnquiryFlowShell, exactly like
// mandatory/survey/review, instead of popping up as a separate modal on top
// of Review.
export default function SubmittedBody() {
  const $ = _c(27);
  const router = useRouter();
  const digitalProfile = useEnquiryFlowStore(_temp);
  const activeStep = useEnquiryFlowStore(_temp2);
  const track = useInhomzTrack();
  let t0;
  if ($[0] !== digitalProfile) {
    t0 = profileEventProps(digitalProfile);
    $[0] = digitalProfile;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  useTrackWhenActive(activeStep === "success", inhomzEvents.submittedScreen.VIEWED, t0);
  const t1 = digitalProfile?.profileName || "The contractor";
  let t2;
  if ($[2] !== t1) {
    t2 = t1.split(" ");
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const contractorFirstName = t2[0];
  const handleClose = _temp3;
  let t3;
  if ($[4] !== digitalProfile || $[5] !== router || $[6] !== track) {
    t3 = () => {
      track(inhomzEvents.submittedScreen.BACK_TO_PROFILE_CLICKED, profileEventProps(digitalProfile));
      leaveFlow(() => {
        if (digitalProfile?.profileLink) {
          router.push(digitalProfile.profileLink);
        }
      });
    };
    $[4] = digitalProfile;
    $[5] = router;
    $[6] = track;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const handleBackToProfile = t3;
  let t4;
  if ($[8] !== digitalProfile || $[9] !== router || $[10] !== track) {
    t4 = () => {
      track(inhomzEvents.submittedScreen.SHOW_MORE_PROFILE_CLICKED, profileEventProps(digitalProfile));
      const cityId = getStoredCityId() ?? LIVE_CITY_ID;
      leaveFlow(() => router.push(`${fevicolInhomzRootRoute}/find-contractors/${cityId}`));
    };
    $[8] = digitalProfile;
    $[9] = router;
    $[10] = track;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const handleShowMoreProfiles = t4;
  let t5;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <IconButton onClick={handleClose} aria-label="Close" className="absolute left-2 top-2 z-10 w-fit" sx={{
      color: "var(--textPrimaryOnColorPrimary)"
    }}><CloseIcon /></IconButton>;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="relative h-24 w-24"><Image src="/icons/success-gif-icon.gif" alt="Success" fill={true} unoptimized={true} className="object-contain" /></div>;
    t7 = <h2 className="m3-headline-small text-[--textPrimaryOnColorPrimary]">Enquiry sent</h2>;
    $[13] = t6;
    $[14] = t7;
  } else {
    t6 = $[13];
    t7 = $[14];
  }
  let t8;
  if ($[15] !== contractorFirstName) {
    t8 = <div className="flex flex-1 flex-col items-center justify-center gap-4 px-8 py-16 text-center">{t6}{t7}<p className="m3-body-medium text-[--textPrimaryOnColorPrimary] opacity-90">{contractorFirstName} will reach out to you within 24 hours.</p></div>;
    $[15] = contractorFirstName;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== handleBackToProfile) {
    t9 = <button type="button" onClick={handleBackToProfile} className="m3-label-large flex h-12 w-full items-center justify-center rounded-[--radius100] bg-[--colorPrimaryPrimary] text-[--textPrimaryOnColorPrimary]">Back to profile</button>;
    $[17] = handleBackToProfile;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== handleShowMoreProfiles) {
    t10 = <button type="button" onClick={handleShowMoreProfiles} className="m3-label-large flex h-12 w-full items-center justify-center rounded-[--radius100] border border-[--colorPrimaryPrimary] bg-transparent text-[--colorPrimaryPrimary]">Show more profiles</button>;
    $[19] = handleShowMoreProfiles;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10 || $[22] !== t9) {
    t11 = <div className="flex flex-col gap-3 rounded-t-[--radius24] bg-[--colorSurfaceSurface] p-4">{t9}{t10}</div>;
    $[21] = t10;
    $[22] = t9;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t11 || $[25] !== t8) {
    t12 = <div className="relative flex h-full w-full flex-col overflow-hidden bg-[--colorSuccessSuccess]">{t5}{t8}{t11}</div>;
    $[24] = t11;
    $[25] = t8;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  return t12;
}
function _temp3() {
  return leaveFlow();
}
function _temp2(state_0) {
  return state_0.activeStep;
}
function _temp(state) {
  return state.digitalProfile;
}